import type { ErrorEvent, EventHint } from "@sentry/remix";

// Array of patterns for third-party scripts that should be ignored in Sentry
// Add new patterns here when needed without changing the filtering logic
const IGNORED_ERROR_PATTERNS = [
  "cdn.vector.co/pixel.js",
  // Add more patterns here in the future as needed
  // Example: 'some-other-cdn.com/script.js',
];

const IGNORED_MESSAGES = [
  "Cloud provider detected",
  "Non-Error promise rejection captured with value: null",
];

export function beforeSend(
  event: ErrorEvent,
  hint: EventHint
): ErrorEvent | null {
  const originalException = hint?.originalException as
    | { message?: string; stack?: string }
    | undefined;

  // Check both message and stack against ignored patterns
  const messageText = originalException?.message || "";
  const stackText = originalException?.stack || "";

  if (
    IGNORED_ERROR_PATTERNS.some(
      pattern => messageText.includes(pattern) || stackText.includes(pattern)
    )
  ) {
    return null;
  }

  if (
    IGNORED_MESSAGES.some(message =>
      messageText.toLowerCase().includes(message.toLowerCase())
    )
  ) {
    return null;
  }

  return event;
}
